import React from 'react';
import { Query } from 'react-apollo';
import { InjectedRouter } from 'react-router';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import CoachingHelpFormView from 'coaching/components/CoachingHelpFormView/CoachingHelpFormView';
import GET_COACHING_HELP_FORM from 'coaching/queries/GetCoachingHelpForm.gql';
import { GetCoachingHelpForm } from 'coaching/queries/__generated__/GetCoachingHelpForm';

type Props = {
  router: InjectedRouter;
};

export default function CoachingHelpFormContainer(props: Props) {
  return (
    <Query<GetCoachingHelpForm> query={GET_COACHING_HELP_FORM}>
      {({ data, loading }) => {
        if (loading) {
          return <CenteredLoadingIndicator />;
        }

        const requester = data?.me ?? null;
        const students = data?.coaching_coachingHomeDashboard?.participants ?? [];

        return <CoachingHelpFormView {...props} students={students} requester={requester} />;
      }}
    </Query>
  );
}
